<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '违章费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
    width="1130px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        style="width: auto;"
      >
        <section slot="car" slot-scope="prop">
          <ChooseCar :isRadio="true" v-model="prop.form.car" @change="handleCarChange" />
        </section>
        <section slot="order" slot-scope="prop">
          <ChooseOrder
            slot="order"
            :isRadio="true"
            v-model="prop.form.order"
            :disabled="!prop.form.car.plateNumber"
            :otherSearchData="{
              plateNumber: prop.form.car.plateNumber,
              orgId,
            }"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
import ChooseOrder from 'components/choose/order';
import {
  getAddressOptions,
  findAddressName,
} from '@qx/utils';
export default {
  components: {
    ChooseCar,
    ChooseOrder,
  },
  props: {
    orgId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        inline: true,
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '牌照类型',
            value: 'licenceTypeName',
            type: 'input',
            placeholder: '请输入牌照类型',
            disabled: true,
          },
          {
            label: '违章类型',
            value: 'categoryId',
            type: 'select',
            placeholder: '请选择违章类型',
            options: [
              {
                label: '电子眼',
                value: '1',
              },
              {
                label: '现场单',
                value: '2',
              },
            ],
          },
          {
            label: '违章时间',
            value: 'violationTime',
            placeholder: '请选择违章时间',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '违章城市',
            value: 'location',
            type: 'cascader',
            default: [],
            options: getAddressOptions(),
            placeholder: '请选择违章城市',
          },
          {
            label: '违章地点',
            value: 'violationAddress',
            type: 'input',
            placeholder: '请输入违章地点',
          },
          {
            label: '违章代码',
            value: 'violationCode',
            type: 'input',
            placeholder: '请输入违章代码',
          },
          {
            label: '罚金',
            value: 'violationFine',
            type: 'input',
            placeholder: '请输入罚金',
            unit: '元',
            onChange: () => {
              this.calcPayamt();
            },
          },
          {
            label: '滞纳金',
            value: 'overdueFine',
            type: 'input',
            placeholder: '请输入滞纳金',
            unit: '元',
            onChange: () => {
              this.calcPayamt();
            },
          },
          {
            label: '扣分数',
            value: 'violationPoint',
            type: 'input',
            placeholder: '请输入扣分数',
          },
          {
            label: '责任人',
            value: 'personLiable',
            type: 'input',
            placeholder: '请输入责任人',
          },
          {
            label: '代办处理费',
            value: 'otherFee',
            type: 'input',
            placeholder: '请输入代办处理费',
            unit: '元',
            onChange: () => {
              this.calcPayamt();
            },
          },
          {
            label: '订单号',
            value: 'order',
            default: {},
            slot: true,
          },
          // 罚金 + 滞纳金 + 代办处理费
          {
            label: '申请金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入申请金额',
            unit: '元',
            disabled: true,
            hide: true,
          },

          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '违章行为',
            value: 'violationReason',
            type: 'input',
            placeholder: '请输入违章行为',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
            hide: true,
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          categoryId: [ // 违章类型
            { required: true, message: '请选择违章类型', trigger: 'blur' },
          ],
          violationTime: [ // 违章时间
            { required: true, message: '请选择违章时间', trigger: 'blur' },
          ],
          violationAddress: [ // 违章地点
            { required: true, message: '请选择违章地点', trigger: 'blur' },
          ],
          violationCode: [ // 违章代码
            { required: true, message: '请输入违章代码', trigger: 'blur' },
          ],
          violationFine: [ // 罚金
            { required: true, message: '请输入罚金', trigger: 'blur' },
          ],
          violationPoint: [ // 扣分数
            { required: true, message: '请输入扣分数', trigger: 'blur' },
          ],
          otherFee: [ // 代办处理费
            { required: true, message: '请输入代办处理费', trigger: 'blur' },
          ],
          personLiable: [ // 责任人
            { required: true, message: '请输入责任人', trigger: 'blur' },
          ],
          violationReason: [ // 违章行为
            { required: true, message: '请输入违章行为', trigger: 'blur' },
          ],
          feeAscriptionDate: [
            { required: true, message: '请输入费用日期', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    // 计算 申请金额 = 罚金 + 滞纳金 + 代办处理费
    calcPayamt () {
      const violationFine = this.$refs.customForm.getVal('violationFine') || 0;
      const overdueFine = this.$refs.customForm.getVal('overdueFine') || 0;
      const otherFee = this.$refs.customForm.getVal('otherFee') || 0;
      const payAmt = ((violationFine * 1000) + (overdueFine * 1000) + (otherFee * 1000)) / 1000;
      this.$refs.customForm.setVal('payAmt', payAmt);
    },
    handleCarChange (item) {
      const car = this.$refs.customForm.getVal('car');
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          item.order = {
            orderId: item.orderId,
          };
          item.location = [item.provinceId, item.locationid];
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
          this.calcPayamt();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      delete form.car;
      // 年审类型
      switch (String(form.categoryId)) {
        case '1':
          form.categoryIdName = '电子眼';
          break;
        case '2':
          form.categoryIdName = '现场单';
          break;
        default:
          form.categoryIdName = '--';
          break;
      }
      // 违章时间
      form.violationTime = this.formatDate(form.violationTime, 1);
      // 费用日期
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      form.orderId = form.order.orderId;
      delete form.order;
      // 地点
      const names = await findAddressName({
        arr: form.location,
      });
      form.provinceId = form.location[0];
      form.provinceName = names[0];
      form.locationid = form.location[1];
      form.locationName = names[1];
      delete form.location;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
